/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const DiscountTag: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.9718 4.52774C12.3978 4.1018 13.0084 3.91691 13.5991 4.03505L13.6169 4.0386L13.6348 4.04151L19.1222 4.93349L19.9572 10.357L19.9606 10.379L19.965 10.4009C20.0831 10.9916 19.8982 11.6022 19.4723 12.0282L11.6178 19.8826C11.4613 20.0391 11.2075 20.0391 11.051 19.8826L4.11739 12.949C3.96087 12.7925 3.96087 12.5387 4.11739 12.3822L11.9718 4.52774ZM10.5576 3.11353C11.4518 2.21934 12.7317 1.82861 13.9722 2.07011L19.4431 2.9594C20.2985 3.09845 20.9671 3.77261 21.0989 4.62917L21.9308 10.0322C22.1705 11.2713 21.7796 12.5493 20.8865 13.4424L13.032 21.2968C12.0945 22.2344 10.5744 22.2344 9.6368 21.2968L2.70318 14.3632C1.76561 13.4256 1.76561 11.9055 2.70318 10.968L10.5576 3.11353ZM14 10C14.5858 10.5858 15.5355 10.5858 16.1213 10C16.7071 9.41422 16.7071 8.46447 16.1213 7.87869C15.5355 7.2929 14.5858 7.2929 14 7.87869C13.4142 8.46447 13.4142 9.41422 14 10Z'
      fill='currentColor'
    />
  </React.Fragment>
)
